import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

/**
 * IconSearchOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2VhcmNoLW9mZiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNS4wMzkgNS4wNjJhNyA3IDAgMCAwIDkuOTEgOS44OW0xLjU4NCAtMi40MzRhNyA3IDAgMCAwIC05LjAzOCAtOS4wNTciIC8+CiAgPHBhdGggZD0iTTMgM2wxOCAxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/search-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSearchOff = createReactComponent('outline', 'search-off', 'SearchOff', __iconNode);

export default IconSearchOff;